import { Button, RocketIcon, Tooltip } from '@chaine/keychaine'
import React from 'react'

/**
 * This is a button that allows users to try the new UI.
 * It is a tooltip that appears when the user hovers over the button.
 * The tooltip text is "Explore the refreshed interface designed for a smoother, faster experience."
 * The button is a link that opens in a new tab.
 * The button is a button that is a link that opens in a new tab.
 */
export const TryNewUi = () => {
  return (
    <Tooltip label="Explore the refreshed interface designed for a smoother, faster experience.">
      <Button
        as="a"
        href="https://app.trychain.com"
        target="_blank"
        rel="noopener noreferrer"
        variant="primary"
        size="md"
        leftIcon={<RocketIcon />}
      >
        Try new UI
      </Button>
    </Tooltip>
  )
}
